import React from 'react';
import PropTypes from 'prop-types';

import { PrsButtonLg, PrsOutlineButtonLg, PrsButtonStackLg } from '../../../styles-and-themes/styles/prsButtons';
import {
  UamHeading,
  UamBodyText,
  UamFlexColumn,
  UamPageIcon,
} from '../../../styles-and-themes/styles/uam-registration-styles';
import StepTransitionOverlay from '../../../components/StepTransitionOverlay/StepTransitionOverlay';
import UamBanner from '../../../components/PrsAlert/UamBanner';
import { frontEndUrl } from '../../../destructured-front-end-config';

const FORWARD_TO_INBOX_ICON_URL = `${frontEndUrl}static/images/forward_to_inbox.svg`;

/**
 * Confirmation panel shown after the user clicks "Verify Another Way" on the
 * MFA OTP screen. Asks them to confirm sending a one-time email link before we
 * actually send.
 */
const VerifyAnotherWayConfirmPanel = ({
  onSendEmail, onCancel, isSubmitting, errorMessage,
}) => (
  <StepTransitionOverlay loading={isSubmitting}>
    <UamFlexColumn gap="0">
      {errorMessage && (
        <UamBanner variant="danger">{errorMessage}</UamBanner>
      )}

      <UamFlexColumn gap="16px" padding={errorMessage ? '24px 0 0' : '0'}>
        {/* TODO: swap to design's envelope-with-dot icon (mark_as_unread) once asset lands. */}
        <UamPageIcon src={FORWARD_TO_INBOX_ICON_URL} alt="" />

        <UamHeading>Verify another way.</UamHeading>

        <UamBodyText>
          We can send a verification link to your email address to confirm it&apos;s you.
        </UamBodyText>

        <PrsButtonStackLg>
          <PrsButtonLg
            type="button"
            style={{ width: '100%' }}
            onClick={onSendEmail}
            disabled={isSubmitting}
          >
            Email Verification Link
          </PrsButtonLg>
          <PrsOutlineButtonLg
            type="button"
            style={{ width: '100%' }}
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </PrsOutlineButtonLg>
        </PrsButtonStackLg>
      </UamFlexColumn>
    </UamFlexColumn>
  </StepTransitionOverlay>
);

VerifyAnotherWayConfirmPanel.defaultProps = {
  isSubmitting: false,
  errorMessage: null,
};

VerifyAnotherWayConfirmPanel.propTypes = {
  onSendEmail: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default VerifyAnotherWayConfirmPanel;
